module.exports = __webpack_public_path__ + "static/woodlands-e5fef94fd3a6c4a59c4b4c1bab8846ec.jpg";